import * as actions from './types';

export function loginUser(userData) {
  return {
    type: actions.LOGIN_USER,
    payload: userData,
  };
}

export function logoutUser() {
  return {
    type: actions.LOGOUT_USER,
  };
}

export function loginCheck() {
  return {
    type: actions.LOGIN_CHECK,
  };
}
